import React from 'react';

import { useApp } from '../../store/AppContext';
import { addDays } from '../../utils/dates';

export default function PeriodNavigation({ periodLabel }) {
  const { NAV_STEP, update } = useApp();
  return (
    <div className="flex items-center gap-[4px] bg-white py-[4px] px-[8px] shadow-[0_1px_4px_rgba(2,56,72,0.06)] [border:1px_solid_#DCE5E7] rounded-[20px]">
      <button
        className="btn [border:none] h-[auto] py-[4px] px-[8px] [background:transparent]"
        onClick={() => update((s) => ({ ...s, tlStart: addDays(new Date(s.tlStart), -NAV_STEP) }))}
      >
        <i className="ti ti-chevron-left text-[15px]" aria-hidden="true" />
      </button>
      <div className="font-bold text-[15px] min-w-[160px] text-center text-navy">{periodLabel}</div>
      <button
        className="btn [border:none] h-[auto] py-[4px] px-[8px] [background:transparent]"
        onClick={() => update((s) => ({ ...s, tlStart: addDays(new Date(s.tlStart), NAV_STEP) }))}
      >
        <i className="ti ti-chevron-right text-[15px]" aria-hidden="true" />
      </button>
    </div>
  );
}
